import type { UploadStatus } from '@/hooks/useBatchUpload';

export const TERMINAL: Set<UploadStatus> = new Set(['completed', 'failed', 'cancelled', 'duplicate']);
